<template lang="pug">
span.icon(:tooltip="tooltip"): font-awesome-icon(:icon="[prefix, icon]", v-bind="$attrs")
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  inheritAttrs: false,
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    prefix: {
      type: String,
      default: 'far'
    },
    icon: String,
    tooltip: String
  }
}
</script>
